import React, { Component } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import About from "./components/home/about";
import Home from "./components/home/home";
import Registration from "./components/home/registration";
import LitterRegistration from "./components/home/litter_registrations";
import DogRegistration from "./components/home/dog_registrations";
// import DogRegistration from './components/home/dog_registrations'
import AdultRegistration from "./components/home/adult_registrations";
import Breeds from "./components/home/breeds/breeds";
import Contact from "./components/home/contact";
// import { SignUp } from './components/sign_login';
import Login from "./components/home/login";
import Register from "./components/home/register";
import Reset from "./components/home/reset";
import Dashboard from "./components/home/dashboard";

import axios from "axios";
import ProfileDog from "./components/home/ProfileDog";
import SignOut from "./components/home/signout";
import Personal from "./components/home/personal";
import PersonalForm from "./components/home/personal2";

import { getAuth, onAuthStateChanged } from "firebase/auth";
import { url } from "./components/weburl";
import { AmericanBulldog } from "./components/home/breeds/americanbulldog";
import { AmericanBully } from "./components/home/breeds/americanbully";
import { FrenchBulldog } from "./components/home/breeds/frenchbulldog";
import { Pittbull } from "./components/home/breeds/pitbull";
import Terms from "./components/home/terms";
import Register_Special from "./components/home/dog_registrations_special";

import { Register_Success } from "./components/home/dog_registrations_success";
import { Litter_Register_Success } from "./components/home/litter_registrations_success";
import { NewlyRegistered } from "./components/community/newly_registered/newly_registered";
import { Post } from "./components/community/posts/posts";
import Ads from "./components/community/advertisements/advertisements";

import { CountryProvider } from "./components/home/country_context";
import RegistrationInternational from "./components/home/registration_international";
import { AdminUsers } from "./components/admin/users/admin_users";
import { AdminMain } from "./components/admin/admin_main";
import { AdminDogsDetail } from "./components/admin/dogs/admin-dogs-detail";
import FeaturedArticlesContent from "./components/community/featured_articles/featured_articles_content";
import FeaturedArticlesFull from "./components/community/featured_articles/featured_articles_full";
import Adverts from "./components/community/advertisements/advertisements";
import { CommunityHome } from "./components/community/community_home/community_home";
import { RegistrationNextPage } from "./components/home/special_registration_next";
import Advertisements from "./components/community/advertisements/advertisements";
import { SearchPage } from "./components/home/searchpage";

import { AdminDogsDetailSpecific } from "./components/admin/dogs/admin-dogs-detail-specific";
import { allowedUsersArray } from "./util.js/allowedUsersArray";
import Profile from "./components/home/profile";
import { ProfileSocials } from "./components/home/profile-socials";
import { ProfileAccount } from "./components/home/profile-account";
import { ProfileBilling } from "./components/home/profile-billing";
import { Email } from "./email/email";
import { UserPublicProfile } from './components/community/user-public-rpofile';

import { HomepageImage } from "./components/admin/HomepageImage/HomepageImage";
import { AdminAllDogs } from "./components/admin/dogs/dogs-listView";
import { AdminAllUsers } from "./components/admin/users/users-listView";
import { AdminUserDetails } from "./components/admin/users/admin-user-details";
import './index.css'

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: "",
      dog_name: "",
      pedigree: {
        maindog: { id: 404 },
        sire: { id: 404 },
        dam: { id: 404 },
        siresire: { id: 404 },
        siredam: { id: 404 },
        damsire: { id: 404 },
        damdam: { id: 404 },
        siresireisre: { id: 404 },
        siresiredam: { id: 404 },
        siredamsire: { id: 404 },
        siredamdam: { id: 404 },
        damsiresire: { id: 404 },
        damsiredam: { id: 404 },
        damdamsire: { id: 404 },
        damdamdam: { id: 404 },
      },
      location: "",
      litter_registrations_price: 20,
      puppy_registrations_price: 30,
      dog_registrations_price: 35,
      allowedAdminUser: false,
      refreshCounter: 0,
    };
  }

  componentDidMount() {
    this.getcurrentuserLocation();
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        this.setState({ ...this.state, user }, () => {
          this.get_user_sql_details();
        });
      } else {
        this.setState({ user: null });
      }

      if (this.state.loading) {
        this.setState({ loading: false });
      }
    });
  }

  getdogpedigree = (id) => {
    if (id) {
      axios
        .get(`${url}api/dogs/pedigree/${id}`)
        .then((res) => {
          this.setState({ pedigree: res.data }, () => {});
        })
        .catch((err) => {
          console.log("Error couldn't get dog id");
          console.log(err.message);
        });
    } else
      axios
        .get(`${url}api/dogs/pedigree/${this.state.dog_id.id}`)
        .then((res) => {
          this.setState({ pedigree: res.data }, () => {
            // console.log('getting pedigree')
            // console.log(this.state.pedigree)
          });
          // console.log('data',data)
        })
        .catch((err) => {
          console.log("Error couldn't get dog id");
          console.log(err.message);
        });
  };

  getcurrentuserLocation = () => {
    // console.log('calling this function actually')

    axios
      .get("https://ipapi.co/json/")

      .then((res) => {
        // console.log(res.data)
        this.setState(
          { ...this.state, location: res.data.country_name },
          () => {
            if (this.state.location === "Ghana") {
              this.setState({ litter_registrations_price: 20.0 });
              this.setState({ puppy_registrations_price: 30.0 });
              this.setState({ dog_registrations_price: 35.0 }, () =>
                console.log(this.state)
              );
              // console.log(this.state.location)
            } else {
              //international prices
              this.setState({ litter_registrations_price: 25.0 });
              this.setState({ puppy_registrations_price: 35.0 });
              this.setState({ dog_registrations_price: 40.0 });
              // this.setState({puppy_registrations_price : 20.00})
              // this.setState({dog_registrations_price : 20.00}, ()=>console.log(this.state))
            }
          }
        );
      })
      .catch((err) => console.log(err));
  };

  get_user_sql_details = () => {
    console.log("calling from profile sql");
    axios
      .get(`${url}api/users/getUserByUid/${this.state.user.uid}`)
      .then((res) => {
        // console.log(res.data)
        this.setState(
          {
            ...this.state,
            user_sql_details: res.data[0],
          },
          () => {
            this.checkIfAdminUser();
          }
        );
      })

      .catch((err) => {
        console.log(err);
      });
  };

  checkIfAdminUser = () => {
    if (allowedUsersArray.includes(this.state.user_sql_details.email)) {
      this.setState({ allowedAdminUser: true });
    }

    console.log(this.state.allowedAdminUser);
    //     console.log(user.user_sql_details.email)
    console.log(allowedUsersArray);
    console.log(allowedUsersArray.includes(this.state.user_sql_details.email));
    //     console.log('an allowed user = ', allowedUser)
    // }

    // console.log('here too')
  };

  refresh = () => {
    this.setState({ refreshCounter: this.state.refreshCounter + 1 });
  };

  render() {
    return (
      <CountryProvider
        value={{
          location: this.state.location,
          user: this.state.user,
          user_sql_details: this.state.user_sql_details,
          allowedAdminUser: this.state.allowedAdminUser,
          refreshCounter: this.state.refreshCounter,
          refresh: this.refresh,
        }}
      >
        <BrowserRouter>
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/registration" element={<Registration />} />
            <Route path="/registration/domestic" element={<Registration />} />
            <Route
              path="/registration/international"
              element={<RegistrationInternational />}
            />

            <Route path="/breeds" element={<Breeds />} />
            <Route
              path="/breeds/americanbulldog"
              element={<AmericanBulldog />}
            />
            <Route path="/breeds/americanbully" element={<AmericanBully />} />
            <Route path="/breeds/frenchbulldog" element={<FrenchBulldog />} />
            <Route path="/breeds/pitbull" element={<Pittbull />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/community" element={<Post />} />
            <Route
              path="/community/newly_registered"
              element={<NewlyRegistered />}
            />

            {/* <Route path='/newly_registered' element={<Newly />} /> */}
            {/* {/* <Route path='/community/posts' element={< Post />} /> */}
            <Route path="/community/posts" element={<Post />} />
            <Route
              path="/community/advertisements"
              element={<Advertisements />}
            />

            <Route path='/community/featured_articles' element={< FeaturedArticlesFull />} />
            <Route path='/community/user/:id/profile' element={< UserPublicProfile />} />

            <Route path="/sign_up" element={<Register />} />
            <Route path="/search-page" element={<SearchPage />} />

            <Route path="/login" element={<Login />} />

            <Route path="/reset" element={<Reset />} />
            <Route path="/dashboard" element={<Dashboard />} />

            <Route
              path="/litter_registrations/:price"
              element={<LitterRegistration />}
            />

            <Route
              path="/litter_registrations_success"
              element={<Litter_Register_Success />}
            />

            <Route
              path="/dog_registrations/:price"
              element={
                <DogRegistration
                  navbar={true}
                  user={this.state.user}
                  puppy_registrations_price={
                    this.state.puppy_registrations_price
                  }
                  transaction_name={"dog_registrations"}
                />
              }
            />

            <Route
              path="/dog_registrations_success/:dog_name/:username/:email/"
              element={<Register_Success navbar={true} />}
            />
            <Route
              path="/dog_registrations_special/:price"
              element={
                <DogRegistration navbar={true} specialRegistration={true} />
              }
            />
            <Route
              path="/special_registration_next"
              element={<RegistrationNextPage />}
            />

            <Route
              path="/dog_registrations/edit/:dog_id"
              element={<DogRegistration />}
            />

            <Route
              path="/dog_registrations/edit/:dog_id/admin"
              element={<DogRegistration redirectToAdmin={true} />}
            />
            <Route
              path="/adult_registrations/:price"
              element={
                <DogRegistration
                  dog_registrations_price={this.state.dog_registrations_price}
                  transaction_name={"adult_registrations"}
                />
              }
            />
            <Route path="/profile" element={<Profile />} />

            <Route path="/my_dogs" element={<Profile />} />
            <Route
              path="/my_dogs/:dog_id"
              element={
                <ProfileDog
                  pedigree={this.state.pedigree}
                  getdogpedigree={this.getdogpedigree}
                />
              }
            />
            <Route
              path="/my_dogs/:dog_id/:dog_name"
              element={
                <ProfileDog
                  pedigree={this.state.pedigree}
                  getdogpedigree={this.getdogpedigree}
                />
              }
            />

            <Route path="/profile/socials" element={<ProfileSocials />} />
            <Route path="/profile/account" element={<ProfileAccount />} />
            <Route path="/profile/billing" element={<ProfileBilling />} />

            <Route path="/profile/signout" element={<SignOut />} />

            <Route
              path="/profile/personal/edit"
              element={<PersonalForm user={this.state.user_sql_details} />}
            />

            <Route path="/terms" element={<Terms />} />

            <Route path="/admin" element={<AdminMain />} />

            <Route path="/admin/dogs" element={< AdminAllDogs />} />
            <Route path="/admin/dogs-detail" element={<AdminDogsDetail />} />
            <Route
              path="/admin/dogs-detail/:dog_id"
              element={<AdminDogsDetailSpecific />}
            />
            <Route
              path="/admin/dogs-detail/:dog_id/:dog_name"
              element={<AdminDogsDetailSpecific />}
            />

            <Route path="/admin/homepage_images" element={<HomepageImage />} />

            <Route path="/admin/users" element={<AdminUsers />} />
            <Route path="/email" element={<Email />} />

            <Route path="/admin/userss" element={<AdminAllUsers />} />
            <Route path="/admin/user/:id" element={<AdminUserDetails />} />

            {/* <Route path="*" element={<Home />} /> */}
          </Routes>
        </BrowserRouter>
      </CountryProvider>
    );
  }
}

export default App;
